import React from 'react';
import AboutSection from '../components/AboutSection';

const About: React.FC = () => {
  return (
    <div className="pt-20">
      <AboutSection />
    </div>
  );
};

export default About;
